import { jsx, Fragment, jsxs } from '@emotion/react/jsx-runtime';
import { useEffect, useState, createContext, useContext } from 'react';
import { css } from '@emotion/react';
import { useInView } from 'react-intersection-observer';
import { createPortal } from 'react-dom';

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _wrapRegExp() {
  _wrapRegExp = function (e, r) {
    return new BabelRegExp(e, void 0, r);
  };
  var e = RegExp.prototype,
    r = new WeakMap();
  function BabelRegExp(e, t, p) {
    var o = new RegExp(e, t);
    return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype);
  }
  function buildGroups(e, t) {
    var p = r.get(t);
    return Object.keys(p).reduce(function (r, t) {
      var o = p[t];
      if ("number" == typeof o) r[t] = e[o];else {
        for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++;
        r[t] = e[o[i]];
      }
      return r;
    }, Object.create(null));
  }
  return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) {
    var t = e.exec.call(this, r);
    if (t) {
      t.groups = buildGroups(t, this);
      var p = t.indices;
      p && (p.groups = buildGroups(p, this));
    }
    return t;
  }, BabelRegExp.prototype[Symbol.replace] = function (t, p) {
    if ("string" == typeof p) {
      var o = r.get(this);
      return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function (e, r) {
        var t = o[r];
        return "$" + (Array.isArray(t) ? t.join("$") : t);
      }));
    }
    if ("function" == typeof p) {
      var i = this;
      return e[Symbol.replace].call(this, t, function () {
        var e = arguments;
        return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e);
      });
    }
    return e[Symbol.replace].call(this, t, p);
  }, _wrapRegExp.apply(this, arguments);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var IntersectionObserver = function IntersectionObserver(_a) {
  var children = _a.children,
    onIntersect = _a.onIntersect,
    style = _a.style,
    className = _a.className,
    options = __rest(_a, ["children", "onIntersect", "style", "className"]);
  var _b = useInView(_assign({
      triggerOnce: true,
      threshold: 0.5
    }, options)),
    ref = _b.ref,
    inView = _b.inView;
  useEffect(function () {
    if (inView) {
      onIntersect();
    }
  }, [inView, onIntersect]);
  return jsx("span", _assign({
    ref: ref,
    css: /*#__PURE__*/css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["height: inherit; display: block;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["height: inherit; display: block;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")]))),
    style: style,
    className: className
  }, {
    children: children
  }));
};
var templateObject_1;

function Portal(_a) {
  var children = _a.children,
    container = _a.container;
  return /*#__PURE__*/createPortal(children, container);
}

function BodyPortal(_a) {
  var children = _a.children;
  var _b = useState(false),
    mounted = _b[0],
    setMounted = _b[1];
  useEffect(function () {
    setMounted(true);
    return function () {
      setMounted(false);
    };
  }, []);
  return mounted ? jsx(Portal, _assign({
    container: document.body
  }, {
    children: children
  })) : jsx(Fragment, {});
}

var ZINDEX = {
  dropdown: 900,
  banner: 1000,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};

var OverlayContext = /*#__PURE__*/createContext(null);
function OverlayProvider(_a) {
  var children = _a.children;
  var _b = useState(null),
    container = _b[0],
    setContainer = _b[1];
  return jsxs(OverlayContext.Provider, _assign({
    value: container
  }, {
    children: [children, jsx(BodyPortal, {
      children: jsx("div", {
        ref: function ref(container) {
          if (container !== null) {
            setContainer(container);
          }
        }
      })
    })]
  }));
}
function OverlayPortal(_a) {
  var children = _a.children;
  var container = useContext(OverlayContext);
  return container ? jsx(Portal, _assign({
    container: container
  }, {
    children: children
  })) : jsx(Fragment, {
    children: children
  });
}

function onCheckHandler(event, callback) {
  if (callback.onChange) {
    callback.onChange(event);
  }
  if (callback.onCheck) {
    callback.onCheck(event.target.checked);
  }
}

function onEnterHandler(event, callback) {
  if (callback.onKeyDown) {
    callback.onKeyDown(event);
  }
  if (callback.onEnter && event.code === 'Enter') {
    callback.onEnter(event);
  }
}

function onValueHandler(event, callback) {
  if (callback.onChange) {
    callback.onChange(event);
  }
  if (callback.onValue) {
    callback.onValue(event.target.value);
  }
}

export { BodyPortal as B, IntersectionObserver as I, OverlayProvider as O, Portal as P, ZINDEX as Z, __makeTemplateObject as _, _assign as a, __spreadArray as b, __awaiter as c, __generator as d, __rest as e, _wrapRegExp as f, OverlayContext as g, OverlayPortal as h, onEnterHandler as i, onValueHandler as j, _typeof as k, onCheckHandler as o };
//# sourceMappingURL=common.js.map
